import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_price_tag_sync_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  store_code: fromDatatype.VarcharDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  scan_code: fromDatatype.VarcharDatatypeInterface;
  sales_unit_price: fromDatatype.BigIntegerDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  namespace: fromDatatype.VarcharArrayDatatypeInterface;
  price_tag_sync_queue_guid: fromDatatype.GuidDataFieldInterface;
  nfc_url: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_mst_price_tag_sync_history_RowClass
  implements bl_fi_mst_price_tag_sync_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  store_code: fromDatatype.VarcharDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  scan_code: fromDatatype.VarcharDatatypeInterface;
  sales_unit_price: fromDatatype.BigIntegerDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  namespace: fromDatatype.VarcharArrayDatatypeInterface;
  price_tag_sync_queue_guid: fromDatatype.GuidDataFieldInterface;
  nfc_url: fromDatatype.VarcharDatatypeInterface;
}
